var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanySidebarLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9289 0L0 24.4189H27.0732L31.9614 51.0918L52.2664 27.0486L47.7542 0L19.9289 0Z",
    fill: "url(#paint0_linear_47056_6169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47056_6169",
    x1: 26.1332,
    y1: 0,
    x2: 26.1332,
    y2: 51.0918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014E4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySidebarLogo);
export default __webpack_public_path__ + "static/media/company-sidebar-logo.c758ce9d72441ae54a966868cc70d742.svg";
export { ForwardRef as ReactComponent };